import { render, staticRenderFns } from "./AbaEditarParticipantesContrato.vue?vue&type=template&id=5b4c750e&scoped=true"
import script from "./AbaEditarParticipantesContrato.vue?vue&type=script&lang=ts"
export * from "./AbaEditarParticipantesContrato.vue?vue&type=script&lang=ts"
import style0 from "./AbaEditarParticipantesContrato.vue?vue&type=style&index=0&id=5b4c750e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c750e",
  null
  
)

export default component.exports